import styled from 'styled-components';

export const Header = styled.div`
  width: 100%;
  height: 224px;
  box-sizing: border-box;

  img {
    width: 100%;
  }
`;

export const BodyWrapper = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  width: 100%;
  padding: 40px;
  padding-top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  max-height: calc(100vh - 300px);

  .MuiOutlinedInput-notchedOutline {
    border: 2px solid #d1d1d1;
  }

  .icon-container {
    position: absolute;
    background-color: white;
    margin-top: -100px;
    z-index: 999999;
    height: 126px;
    width: 126px;
    box-shadow: 0px 9px 15px #00000015;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
    box-sizing: border-box;

    svg {
      fill: ${(props) => (props?.error ? '#BA122B' : props.tema.primaryColor)};
      height: 80px;
      width: 110px;
    }
  }

  .title {
    color: ${(props) => (props.error ? '#BA122B' : props.tema.primaryColor)};
    font-size: 26px;
    font-weight: bold;
    margin-top: 60px;
    margin-bottom: 8px;
    display: flex;
    width: 100%;
    justify-content: center;
  }

  .message {
    font-size: 18px;
    color: #4d4d4d;
    margin-bottom: 38px;
  }

  .container-buttons {
    display: flex;
    width: 100%;
    gap: 12px;
  }

  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 32px;

    .container-buttons {
      flex-direction: column;
    }
  }
`;

export const ModalWrapper = styled.div`
  border: 2px solid #d1d1d1;
  border-radius: 10px;
  position: relative;
  background: #fff;
  width: 640px;
  height: 502px;
  height: fit-content;
  box-sizing: border-box;
  margin: auto;
  color: #4d4d4d;

  * {
    box-sizing: border-box;
  }
  overflow: auto;

  @media (max-width: 768px) {
    width: 100%;
    overflow: auto;
  }
`;
